import { ReactComponent as SearchIcon } from "../assets/icons/search_icon.svg"
import { InlineIndicator } from "./loader"
import { ClearButton } from "./buttons"
import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react"

const DEFAULT_PLACEHOLDER = "Search"

const Search = forwardRef(function Search(
  { placeholder = DEFAULT_PLACEHOLDER, search, isSearching, onSearch, ...props },
  ref
) {
  const [text, setText] = useState(() => search || "")
  const updateText = newText => {
    setText(() => newText || "")
  }

  const inputRef = useRef(null)
  const timerRef = useRef(null)
  // Use ref for onSearch to avoid re-running effect when callback reference changes
  const onSearchRef = useRef(onSearch)
  onSearchRef.current = onSearch

  // Expose clear method via ref
  useImperativeHandle(ref, () => ({
    clear: () => updateText("")
  }))

  useEffect(() => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }

    const handler = () => {
      const value = text?.length > 0 ? text : null
      onSearchRef.current?.(value)
    }

    timerRef.current = setTimeout(handler, 250)
    return () => {
      clearTimeout(timerRef.current)
      timerRef.current = null
    }
  }, [text])

  const showClearButton = text?.length > 0

  let { className } = props

  if (className == null) className = "da-search"
  else className += " da-search"

  return (
    <div className={className} onClick={() => inputRef.current?.focus()}>
      <SearchIcon />
      <input
        className="da-search-input"
        ref={inputRef}
        type="text"
        placeholder={placeholder}
        value={text}
        onChange={e => {
          updateText(e.target.value)
        }}
      />
      <InlineIndicator show={isSearching} />
      {showClearButton && <ClearButton onClick={() => updateText()} />}
    </div>
  )
})

export default Search
